import React from "react";

const DottedLoadingData = ({ withText }) => {
  return (
    <div className="vh-100">
      {withText == "false" ? (
        ""
      ) : (
        <div className="text-center">در حال دریافت اطلاعات ...</div>
      )}

      <div class="lds-ellipsis">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
export default DottedLoadingData;
